module.exports = __webpack_public_path__ + "img/anejo-15-informe-de-altas.d49aa9ce.svg";